import type { Service } from '@criteria-labs/docs-kit'
import { InspectorBody } from '../article'
import { BaseURLsSection } from '../base-url/BaseURLsSection'
import { APIKeySecuritySchemesSection } from '../security-scheme/APIKeySecuritySchemesSection'
import { HTTPSecuritySchemesSection } from '../security-scheme/HTTPSecuritySchemesSection'
import { OAuth2SecuritySchemesSection } from '../security-scheme/OAuth2SecuritySchemesSection'
import { OpenIDConnectSecuritySchemesSection } from '../security-scheme/OpenIDConnectSecuritySchemesSection'

export function ServiceAuthentication({ service }: { service: Service }) {
  const securitySchemes = service.openAPI.components?.securitySchemes ?? {}
  return (
    <InspectorBody>
      <BaseURLsSection servers={service.openAPI.servers ?? []} />
      <APIKeySecuritySchemesSection securitySchemes={securitySchemes} />
      <HTTPSecuritySchemesSection securitySchemes={securitySchemes} />
      <OAuth2SecuritySchemesSection securitySchemes={securitySchemes} />
      <OpenIDConnectSecuritySchemesSection securitySchemes={securitySchemes} />
    </InspectorBody>
  )
}
